const COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION
const COGNITO_USER_POOL = process.env.REACT_APP_COGNITO_USER_POOL
const COGNITO_WEB_CLIENT = process.env.REACT_APP_COGNITO_WEB_CLIENT

const config = {
  Auth: {
    Cognito: {
      region: COGNITO_REGION,
      userPoolId: COGNITO_USER_POOL,
      userPoolClientId: COGNITO_WEB_CLIENT,
      loginWith: {
        username: true,
        email: true,
      },
      authenticationFlowType: 'USER_SRP_AUTH',
    },
  },
  Storage: {
    S3: {
      region: COGNITO_REGION,
    },
  },
}

const awsConfig = config

export default awsConfig
